module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/UA-75e698f10268bb9550f1cf2b2eab93e2.png";